import * as React from 'react';
import { useSelector } from 'react-redux';

import { CallToActionContainer, ICallToActionContainerProps } from '../CallToAction';
import { getHasOffersFromDeveloper } from '../../selectors/newbuilding';
import { SelectionsButton } from '../../components/SelectionsButton';
import { trackSelectionButtonClick } from './tracking';
import { useApplicationContext } from '../../utils/applicationContext';
import { getNewbuildingSelectionsUrl } from '../../utils/config';

type TActionButtonProps = ICallToActionContainerProps;

export function ActionButtonContainer(props: TActionButtonProps) {
  const { config } = useApplicationContext();
  const { fullWidth, XXL, secondary } = props;
  const hasOffersFromDeveloper = useSelector(getHasOffersFromDeveloper);
  const selectionsUrl = getNewbuildingSelectionsUrl(config);

  const onSelectionsButtonClick = React.useCallback(() => {
    trackSelectionButtonClick();
  }, []);

  if (!hasOffersFromDeveloper) {
    return (
      <SelectionsButton
        onClick={onSelectionsButtonClick}
        href={selectionsUrl}
        fullWidth={fullWidth}
        XXL={XXL}
        secondary={secondary}
      />
    );
  }

  return <CallToActionContainer {...props} />;
}
